import { getHostName, convertToUTC } from "../utils";
import { cachedGet } from "./requestCache.js";

export async function fetchZones(query, filter) {
  const key = `landingzones:${query || ""}`;
  return cachedGet(key, async () => {
    const data = await fetch(`${getHostName()}/api/landingzones/?format=json&query=${query}`);
    return data.json();
  });
}

export async function fetchZoneInfo(id, startDate) {
  const dateKey = startDate ? convertToUTC(startDate) : "";
  const key = `landingzoneinfo:${id}:${dateKey}`;

  return cachedGet(key, async () => {
    const data = await fetch(
      `${getHostName()}/api/landingzoneinformation/?id=${id}${dateKey ? `&startdate=${dateKey}` : ""}&format=json`
    );

    if (!data.ok) {
      throw new Error("Recovery Zone Not Found");
    }

    return data.json();
  });
}
